import { useFetch } from 'app/queryProvider';
import { IPathwayDocumentsResponse } from '../types/Documents';
import { buildHistoryQueryString } from '../utils/historyQuery';

export const useHistoryDocuments = (
  pathwayId: string,
  createdAtRanges?: string[] | null,
) => {
  const queryString = buildHistoryQueryString({
    createdAtRanges,
    extraParams: { patient_access: 'true' },
  });

  const { data, isLoading, isRefetching, refetch } = useFetch<IPathwayDocumentsResponse>({
    url: `/documents?${queryString}`,
    queryKey: [['pathway-documents', pathwayId, queryString]],
    resource: { name: 'pathways', id: pathwayId },
    options: { enabled: !!pathwayId },
  });

  return {
    documents: data?.results ?? [],
    isLoading,
    isRefetching,
    refetch,
  };
};
